// extracted by mini-css-extract-plugin
module.exports = {"accent":"Accent_accent__YKaP5","accent-small":"Accent_accent-small__ITvfh"};